export default "skymp5-front/b15068af18f5c098511463ef27285c59.gif";